/**
 * Build the sorted set of tag values to expose in a column filter dropdown,
 * restricted to memberships the organizer can see.
 *
 * The local cache (`tagValueMap`) is populated from `allWorkspaceMembershipTagsQuery`,
 * which intentionally returns rows for every membership in the workspace — including
 * drivers the current organizer has no permission on. Enumerating those rows directly
 * surfaces filter options (e.g. branches/locations) for which the organizer would see
 * zero matching drivers, producing a "No Results" state when selected. Restricting to
 * the visible membership set keeps the filter options aligned with the rendered table.
 */
export function uniqueTagValuesForVisibleDrivers(
  tagId: string,
  tagValueMap: Map<string, Record<string, string[]>>,
  visibleMembershipIds: Iterable<string>,
): string[] {
  const allValues = new Set<string>();
  for (const membershipId of visibleMembershipIds) {
    for (const v of tagValueMap.get(membershipId)?.[tagId] ?? []) {
      allValues.add(v);
    }
  }
  return [...allValues].sort();
}
